import React, { useState } from 'react';
import { Form, Input, Button, Typography } from 'antd';
import makeApiRequest from '@apiCalls/makeApiRequest';
import { API_ENDPOINTS } from '@constants/apiEndpoints';
import { useNotification } from '@providers/NotificationProviders';
import type apiRequestConfig from '@interfaces/apiEndpoints.interface';
import * as styles from '@styles/costcoSubscription.module.scss';
import CheckCircleThin from '@assets/check-circle-thin.png';

const { Title } = Typography;

const CostcoSubscription: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [verified, setVerified] = useState(false);
  const openNotification = useNotification();
  const onFinish = (values: any) => {
    setLoading(true);
    const response = makeApiRequest(
      values,
      API_ENDPOINTS.COSTCO_SUBSCRIBE as apiRequestConfig,
      ''
    );
    response
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setVerified(true);
          // openNotification('Subscribed successfully', 'Success');
        }
        else if (res.status === 400) {
          setVerified(false);
          // openNotification(res.data?.message, 'Error');
        }
      })
      .catch((err) => {
        setLoading(false);
        // openNotification(err.response?.data?.message, 'Error');
        form.setFields([
          {
            name: 'email',
            errors: [err.response?.data?.message],
          },
        ]);
      });
  };

  const handleVerifyNew = () => {
    setVerified(false);
    form.resetFields();
  };

  return (
      <section className={styles.formLogin}>
        {verified ? (
          <div className={styles.successDiv}>
            <img src={CheckCircleThin} alt="Check Circle" className={styles.successLogo} />
            <Title className={styles.titleForm} level={1}>
              Subscribed successfully
            </Title>
            <Button
              className={styles.verifyNew}
              type="primary"
              onClick={handleVerifyNew}
            >
              Back
            </Button>
          </div>
        ) : (
          <Form
            form={form}
            name="basic"
            layout="vertical"
            initialValues={{ remember: true }}
            className={styles.loginForm}
            onFinish={onFinish}
          >
            <Title className={styles.verificationTitle}>
              Costco Subscription
            </Title>
            <section className={styles.inputs}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Please enter email',
                  },
                  {
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Please enter a valid email address',
                  },
                ]}
                className={styles.loginInput}
              >
                <Input placeholder="Enter email" />
              </Form.Item>
              <Form.Item>
                <Button
                  className={styles.formBtn}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Subscribe
                </Button>
              </Form.Item>
            </section>
          </Form>
        )}
      </section>
  );
};

export default CostcoSubscription;
